<template>
	<div>
		<programm-header
			v-if="eventPage && eventPage.typology === TYPOLOGY.PROGRAM"
			ref="program-header"
			:fetched-data="eventPage"
			:links="links"
		/>
		<article-short-header
			v-else
			:fetched-data="fetchedData"
		/>

		<alumni-header v-if="check" />

		<div v-if="isAlumni || !notAlumniPage">
			<div>
				<div v-if="fetchedData.content_type !== 3">
					<article>
						<header class="article-header theme-light">
							<div class="container">
								<div class="row">
									<div class="col-12 col-lg-2">
										<div :class="'type ' + contentIconMap[fetchedData.content_type]" />
										<div class="date">
											{{ fetchedData.date | moment('DD MMMM YYYY') }}
										</div>
										<div class="tag_string">
											<span v-if="$i18n.locale ==='ru'">
												{{ contentTypeMapRu[fetchedData.content_type] }}
											</span>
											<span v-else>
												{{ contentTypeMapEn[fetchedData.content_type] }}
											</span>
										</div>
									</div>
									<div class="col-12 col-lg-9 offset-lg-1">
										<div class="article-title-block">
											<div class="breadcrumbs-block">
												<ol v-if="$i18n.locale ==='ru'" class="breadcrumb">
													<li class="breadcrumb-item">
														<nuxt-link to="/intrend/">
															inTrend
														</nuxt-link>
													</li>
													<li v-if="fetchedData.taxonomy.project" class="breadcrumb-item">
														<nuxt-link to="/intrend/">
															{{ fetchedData.taxonomy.project.title }}
														</nuxt-link>
													</li>

													<li v-if="fetchedData.taxonomy.product" class="breadcrumb-item">
														<nuxt-link to="/intrend/">
															{{ fetchedData.taxonomy.product.title }}
														</nuxt-link>
													</li>
												</ol>
												<ol v-else class="breadcrumb">
													<li class="breadcrumb-item">
														<nuxt-link to="/en/">
															Main
														</nuxt-link>
													</li>
												</ol>
											</div>
											<h1>{{ fetchedData.title }}</h1>
										</div>
									</div>
								</div>
							</div>
						</header>
						<div ref="sticky-container" class="article-content">
							<div class="container">
								<!-- Заходной блок с лидом и авторами -->
								<div class="row header-block">
									<div class="col-12 col-lg-7 offset-lg-1 order-lg-1">
										<div
											v-if="fetchedData.content_type === 1"
											class="embed-responsive embed-responsive-16by9"
											v-html="fetchedData.announce_video"
										/>
										<div v-if="fetchedData.intro !==null" class="lead">
											{{ fetchedData.intro }}
										</div>
										<!-- 0 - статья, 2, подкаст, 1 видео -->
										<div v-if="fetchedData.content_type === 2" v-html="fetchedData.announce_audio" />
										<div v-if="fetchedData.content_type === 0" class="lead-image">
											<b-img-lazy
												:src="fetchedData.listing_cover_image_url_facebook || ''"
												:alt="fetchedData.title"
												blank-color="lightgray"
												center
												block
											/>
											<div
												v-if="fetchedData.photo_sources !== null"
												class="image-caption"
											>
												{{ $t('contentSource') }}: {{ fetchedData.photo_sources }}
											</div>
										</div>

										<!-- end: Блок вставки во всю ширину в разрыв контента ? -->
										<div
											v-for="(block, index) in fetchedData.blocks"
											:key="index"
											class="position-relative mb-4"
										>
											<component
												:is="block.type"
												v-if="block.type === 'wysiwyg' ||
													block.type === 'wysiwyg-with-entities' ||
													block.type === 'video-embed' ||
													block.type === 'content-image' ||
													block.type === 'gallery' ||
													block.type === 'panel-cards' ||
													block.type === 'panel-kpcw01' ||
													block.type === 'panel-kpcw02' ||
													block.type === 'panel-kpcw03' ||
													block.type === 'panel-kpcw04' ||
													block.type === 'panel-kpcw05' ||
													block.type === 'panel-authored-review' ||
													block.type === 'panel-recommended-articles'"
												:ref="block.type"
												:block="block"
												:content="block.content"
												:entities="block.entities"
												:image_data="block.image_data"
												:images="block.images"
												:fetched-data="fetchedData"
												:static_content="block.static_content"
											/>
										</div>
										<div class="col-12 d-flex mb-5">
											<event-stars
												class="stars"
												:entity_id="fetchedData.id"
												:entity="'taxonomy'"
											/>
										</div>
									</div>
									<div class="col-12 col-lg-2 sticky-container">
										<div class="content-info">
											<div class="share d-none d-lg-block">
												<social-sharing inline-template>
													<div class="share_list">
														<network network="vk">
															<i class="icon-vk" />
														</network>
														<network network="telegram">
															<i class="ml-3 icon-telegram" />
														</network>
													</div>
												</social-sharing>
												<hr>
											</div>
											<div v-if="fetchedData.content_type === 2">
												<div v-if="fetchedData.people !==null" class="author_data">
													<div v-for="(author, index) in fetchedData.people" :key="index">
														<div v-if="index === 0" class="author_title">
															Ведущий
															<span class="author_text">{{ author.title }}</span>
														</div>
														<div v-else class="author_title">
															Гость
															<span class="author_text">{{ author.title }}</span>
														</div>
													</div>
													<div v-if="fetchedData.content_source !==null" class="author_title">
														{{ $t('contentSource') }}
														<span class="author_text">
															<a
																:href="fetchedData.content_source.url"
																target="_blank"
																rel="nofollow noopener noreferrer"
															>{{ fetchedData.content_source.url_title }}</a>
														</span>
													</div>
												</div>
											</div>
											<div v-if="fetchedData.content_type === 0">
												<div class="author_data">
													<div v-if="fetchedData.people !==null && fetchedData.people.length ===1">
														<div
															v-for="(author, index) in fetchedData.people"
															:key="index"
														>
															<div
																v-if="author.square_photo !==null"
																class="author_image d-none d-lg-block"
															>
																<img :src="author.square_photo" :alt="author.title">
															</div>
															<div class="author_title">
																{{ $t('author') }}
																<span class="author_text">{{ author.title }}</span>
															</div>
														</div>
													</div>
													<div v-if="fetchedData.people.length !==1">
														<div class="author_title">
															<p>{{ $t('authors') }}</p>
															<p
																v-for="(author, index) in fetchedData.people"
																:key="index"
																class="author_text mb-0"
															>
																{{ author.title }}
															</p>
														</div>
													</div>
													<div v-if="fetchedData.content_source !==null" class="author_title">
														{{ $t('contentSource') }}
														<span class="author_text">
															<a
																:href="fetchedData.content_source.url"
																target="_blank"
																rel="nofollow noopener noreferrer"
															>
																<template v-if="fetchedData.url_title">
																	{{ fetchedData.content_source.url_title }}
																</template>
																<template v-else>
																	{{ fetchedData.content_source.title }}
																</template>
															</a>
														</span>
													</div>
												</div>
											</div>
											<div v-if="fetchedData.content_type === 1">
												<div class="author_data">
													<template v-for="(author, index) in fetchedData.people">
														<div
															v-if="fetchedData.people !==null && fetchedData.people.length === 1"
															:key="index"
														>
															<div class="author_title">
																{{ $t('author') }}
																<span class="author_text">{{ author.title }}</span>
															</div>
														</div>
													</template>
													<div v-if="fetchedData.people.length !==1">
														<div class="author_title">
															{{ $t('authors') }}
															<template v-for="(author, index) in fetchedData.people">
																<span
																	v-if="fetchedData.people !==null"
																	:key="index"
																	class="author_text"
																>{{ author.title }}</span>
															</template>
														</div>
													</div>
													<div v-if="fetchedData.content_source !==null" class="author_title">
														{{ $t('contentSource') }}
														<span class="author_text">
															<a
																:href="fetchedData.content_source.url"
																target="_blank"
																rel="nofollow noopener noreferrer"
															>{{ fetchedData.content_source.url_title }}</a>
														</span>
													</div>
												</div>
											</div>

											<div class="mt-4">
												<button
													v-if="inLibrary"
													class="btn btn-secondary-outer"
													:title="$t('delToLibrary')"
													@click="delLibraryItem"
												>
													{{ $t('delToLibrary') }}
												</button>
												<button
													v-else-if="!inLibrary"
													class="btn btn-primary"
													:title="$t('addToLibrary')"
													@click="addLibraryItem"
												>
													{{ $t('addToLibrary') }}
												</button>
											</div>

											<div
												v-if="fetchedData.taxonomy_type === 10"
												class="mt-4 sticky-parent d-none d-lg-block"
											>
												<div
													ref="sticky-element"
													class="sidebar-menu sticky is_stuck"
												>
													<ul>
														<li>
															<button
																v-for="(item, index) in cardMenuItems"
																:key="index"
																:ref="'btn-' + index"
																v-scroll-to="item.uri"
																class="btn text-left rounded-0 mb-1 btn-block"
															>
																{{ item.title }}
															</button>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- end: Блок вставки во всю ширину в разрыв контента ? -->
								<!--end: container -->
							</div>
						</div>
					</article>

					<div
						v-for="(block, index) in fetchedData.blocks"
						:key="index"
					>
						<component
							:is="block.type"
							v-if="block.type !== 'wysiwyg' &&
								block.type !== 'wysiwyg-with-entities' &&
								block.type !== 'video-embed' &&
								block.type !== 'content-image' &&
								block.type !== 'content-footer' &&
								block.type !== 'gallery' &&
								block.type !== 'panel-cards' &&
								block.type !== 'panel-kpcw01' &&
								block.type !== 'panel-kpcw02' &&
								block.type !== 'panel-kpcw03' &&
								block.type !== 'panel-kpcw04' &&
								block.type !== 'panel-kpcw05' &&
								block.type !== 'panel-authored-review' &&
								block.type !== 'panel-recommended-articles'"
							:ref="block.type"
							:index="index"
							:block="block"
							:content="block.content"
							:entities="block.entities"
							:image_data="block.image_data"
							:images="block.images"
							:fetched-data="fetchedData"
							:static_content="block.static_content"
						/>
					</div>
				</div>
				<div v-else>
					<div class="questions-header theme-light">
						<div class="panel_header">
							<div class="container">
								<div class="row">
									<div class="col-12 col-lg-2">
										<div class="type icon-speak" />
										<div class="date">
											{{ fetchedData.date | moment('DD MMMM YYYY') }}
										</div>
										<ul class="tag_string">
											<li>
												<nuxt-link to="/media/">
													inTrend
												</nuxt-link>
											</li>
											<li>
												<nuxt-link to="/media/?taxonomyType=8&page=1">
													{{ $t('qa') }}
												</nuxt-link>
											</li>
										</ul>
									</div>
									<div class="col-12 col-lg-9 offset-lg-1">
										<div class="questions-title-block">
											<div class="title">
												{{ $t('qa') }}
											</div>
											<h1>{{ fetchedData.title }}</h1>
											<div class="description">
												{{ fetchedData.intro }}
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12" />
								</div>
							</div>
						</div>
					</div>

					<div
						v-for="(block, index) in fetchedData.blocks"
						:key="index"
					>
						<component
							:is="block.type"
							:block="block"
							:content="block.content"
							:entities="block.entities"
							:image_data="block.image_data"
							:images="block.images"
							:fetched-data="fetchedData"
							:static_content="block.static_content"
						/>
					</div>
				</div>
				<event-stars
					class="stars"
					:entity_id="fetchedData.id"
					:entity="'taxonomy'"
				/>
				<div v-if="$i18n.locale ==='ru'" id="subscribe_short" class="panel form subscribe-short theme-inverse py-5">
					<div class="container">
						<div class="row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-8">
								<div class="title mb-4">
									Подпишитесь на рассылку inTrend
								</div>
								<div class="subscribe_block">
									<form action="" @submit.prevent="formSubmit">
										<div class="form-row">
											<div class="form-group col-12 col-md-6 col-lg-6">
												<input
													id="first_name"
													v-model="$v.subscribeForm.firstName.$model"
													data-msg="Пожалуйста, укажите ваше имя"
													name="first_name"
													placeholder="Имя*"
													type="text"
													class="form-control rounded-0 required"
												>
												<label
													v-if="$v.subscribeForm.firstName.$invalid && subscribeForm.triedToSend"
													class="input-error"
													for="first_name"
												>Пожалуйста, укажите ваше имя</label>
											</div>
											<div class="form-group col-12 col-md-6 col-lg-6">
												<input
													id="last_name"
													v-model="$v.subscribeForm.lastName.$model"
													data-msg="Пожалуйста, укажите вашу фамилию"
													name="last_name"
													placeholder="Фамилия*"
													type="text"
													class="form-control rounded-0 required"
												>
												<label
													v-if="$v.subscribeForm.lastName.$invalid && subscribeForm.triedToSend"
													class="input-error"
													for="last_name"
												>Пожалуйста, укажите вашу фамилию</label>
											</div>
											<div class="form-group col-12 col-md-6 col-lg-6">
												<input
													id="email"
													v-model="$v.subscribeForm.email.$model"
													data-msg="Пожалуйста, укажите ваш email"
													name="email"
													type="email"
													placeholder="Email*"
													class="form-control rounded-0 required"
												>
												<label
													v-if="$v.subscribeForm.email.$invalid && subscribeForm.triedToSend"
													class="input-error"
													for="email"
												>Пожалуйста, укажите ваш email</label>
											</div>
											<div
												class="form-group col-12 col-md-6 col-lg-6"
												:class="{
													'form-group--error':
														showPhoneValidationError,
												}"
											>
												<VuePhoneNumberInput
													id="phone"
													ref="phoneInput"
													v-model="mobilePhone"
													name="phone"
													color="#000000"
													default-country-code="RU"
													:border-radius="0"
													:no-country-selector="false"
													:no-flags="true"
													:no-example="true"
													:show-code-on-list="true"
													:translations="{
														countrySelectorLabel: '',
														countrySelectorError: $t(
															'countrySelectorError'
														),
														phoneNumberLabel: `${$t('phoneNumberLabel')}*`,
														example: $t('exampleEvent'),
													}"
													@update="phoneUpdate"
												/>
												<label
													v-if="showPhoneValidationError"
													class="input-error"
													for="phone"
												>{{ $t('fillPhoneMessage') }}</label>
											</div>
										</div>
										<div class="form-row">
											<div class="form-group col-12 custom-control custom-checkbox">

												<div v-if="showPersonalData" class="form-check">
													<input
														id="condition_checkbox"
														v-model="$v.agreements.personal_data.$model"
														data-msg="Необходимо принять условия"
														name="terms"
														type="checkbox"
														class="rounded-0 required form-check-input custom-control-input"
														data-action="project-detail-personal-data-processing-agreement"
													>
													<label
														class="custom-control-label form-check-label"
														for="condition_checkbox"
													>
														Согласен с
														<a
															href="https://www.skolkovo.ru/static/personaldata_rus.html"
															target="_blank"
														>условиями обработки и хранения персональных данных</a>
													</label>
													<label
														v-if="!$v.agreements.personal_data.checked && subscribeForm.triedToSend"
														class="input-error"
														for="condition_checkbox"
													>Необходимо принять условия</label>
												</div>
												<div v-if="showMarketingEmails" class="form-check">
													<input
														id="marketing_checkbox"
														v-model="agreements.marketing_emails"
														type="checkbox"
														name="marketingEmailsAgreement"
														class="custom-control-input"
														data-action="checkout-marketing-emails-agreement"
													>
													<label
														class="custom-control-label"
														for="marketing_checkbox"
													>{{ $t('isAgreesToMarketingEmails') }}</label>
												</div>
											</div>
										</div>
										<div class="form-row">
											<div class="form-group col-12 pb-0">
												<button type="submit" class="btn btn-primary">
													Подписаться
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
							<div class="col-12 col-lg-4 column_info d-flex align-items-center">
								<div class="overview_block mb-0 d-none d-lg-block">
									<div class="description mb-0">
										<p>
											Подписывайтесь, чтобы узнавать об актуальных событиях, свежих материалах и
											новостях
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<article-useful-content
					v-if="!eventPage && $i18n.locale ==='ru'"
					:category="fetchedData.category_id"
					:taxonomy_type="fetchedData.taxonomy_type_slug"
				/>

				<div v-if="eventPage && eventPage.typology === TYPOLOGY.PROGRAM">
					<div
						v-for="(block, index) in eventPage.blocks"
						:key="index"
					>
						<component
							:is="block.type"
							v-if="block.type === 'panel-smart-form'"
							:ref="block.type"
							:index="index"
							:block="block"
							:content="block.content"
							:fetched-data="eventPage"
							:static_content="block.static_content"
							:block_title="block.block_title"
						/>
					</div>
				</div>
			</div>
		</div>
		<main-footer />
	</div>
</template>

<script>
import '@/utils/moment';
import { mapActions, mapMutations } from 'vuex';
import _find from 'lodash/find';

import { validationMixin } from 'vuelidate';
import { email, maxLength, required } from 'vuelidate/lib/validators';

import axios from 'axios';

import { TYPOLOGY } from '~/utils/dictionaries';
import jsonldForArticles from '~/utils/seo/jsonldForArticles';
import panels from '~/mixins/panels';
import googleAnalytics from '~/mixins/googleAnalytics';
import agreementsMixin from '~/mixins/agreementsMixin';
import ContentFooter from '~/components/blocks/content/ContentFooter.vue';
import ContentImage from '~/components/blocks/content/ContentImage.vue';
import ProgrammHeader from '~/components/layouts/headers/ProgrammHeader.vue';
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import ArticleUsefulContent from '~/components/refactor/ArticleUsefulContent.vue';
import EventStars from '~/components/refactor/EventStars.vue';
import ArticleShortHeader from '~/components/layouts/headers/ArticleShortHeader.vue';
import AlumniHeader from '~/components/alumniHeader.vue';
import PanelAuthoredReview from '~/components/panels/PanelMedia/PanelAuthoredReview.vue';
import PanelRecommendedArticles from '~/components/panels/PanelMedia/PanelRecommendedArticles.vue';
import stickyMixin from '~/mixins/stickyMixin';
import VuePhoneNumberInput from 'vue-phone-number-input';
import makeCanonicalLink from '~/utils/seo/makeCanonicalLink';

export default {
	components: {
		AlumniHeader,
		EventStars,
		ContentFooter,
		ContentImage,
		ArticleShortHeader,
		MainFooter,
		ArticleUsefulContent,
		ProgrammHeader,
		PanelAuthoredReview,
		PanelRecommendedArticles,
		VuePhoneNumberInput,
	},
	mixins: [panels, googleAnalytics, validationMixin, agreementsMixin, stickyMixin],
	async asyncData({
		app,
		params,
		redirect,
		query,
		route,
		store,
	}) {
		const { $pagesApi, i18n } = app;
		const {
			mediaTypeSlug,
			slug,
		} = params;
		const { eventId } = query;

		const [fetchedData, eventPage] = await Promise.all([
			$pagesApi.contentView(slug),
			(eventId ? $pagesApi.eventById(eventId) : null),
			store.dispatch('profile/getRoles'),
		]);

		if (!fetchedData) return {};

		i18n.setLocale(fetchedData.language);

		return {
			fetchedData,
			eventPage,
		};
	},
	data() {
		return {
			fetchedData: {},
			subscribeForm: {
				triedToSend: false,
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
			},
			eventPage: null,
			TYPOLOGY,
			contentTypeMapRu: {
				0: 'Статья',
				1: 'Видео',
				2: 'Подкаст',
				3: 'Вопросы и ответы',
			},
			contentTypeMapEn: {
				0: 'Article',
				1: 'Video',
				2: 'Podcast',
				3: 'Q&A',
			},
			contentIconMap: {
				0: 'icon-text',
				1: 'icon-video',
				2: 'icon-audio',
				3: 'icon-speak',
			},
			inLibrary: null,
			entity: 'usefulContent',
			entity_id: null,
			isShowLoginModal: true,
			stickyKit: {
				element: 'sticky-element',
				container: 'sticky-container',
				offset_top: 70,
				from: 1260,
			},
			mobilePhone: '',
			countryCode: null,
			isMobilePhoneValid: false,
			showPhoneValidationError: false,
		};
	},
	validations() {
		return {
			subscribeForm: {
				firstName: {
					required,
					maxLength: maxLength(150),
				},
				lastName: {
					required,
					maxLength: maxLength(150),
				},
				email: {
					required,
					email,
				},
				phone: { required },
			},
			agreements: this.agreements_validation,
		};
	},
	head() {
		return {
			title: this.fetchedData.meta_title,
			link: [
				{
					rel: 'canonical',
					hid: 'canonical',
					href: makeCanonicalLink(this.$route.path),
				},
			],
			meta: [
				{
					hid: 'robots',
					name: 'robots',
					content: this.fetchedData.meta_indexing,
				},
				{
					name: 'description',
					hid: 'description',
					content: this.fetchedData.meta_description,
				},
				// Open Graph
				{
					name: 'og:title',
					hid: 'og:title',
					content: this.fetchedData.meta_title,
				},
				{
					name: 'og:description',
					hid: 'og:description',
					content: this.fetchedData.meta_description,
				},
				{
					name: 'og:type',
					hid: 'og:type',
					content: 'article',
				},
				{
					name: 'og:image',
					hid: 'og:image',
					content: this.fetchedData.smm_image_default.src || this.fetchedData.listing_cover_image_facebook.src,
				},
				// Twitter Card
				{
					name: 'twitter:card',
					content: 'summary',
				},
				{
					name: 'twitter:site',
					content: '@nuxt_js',
				},
				{
					name: 'twitter:title',
					content: this.fetchedData.meta_title,
				},
				{
					name: 'twitter:description',
					content: this.fetchedData.meta_description,
				},
				{
					name: 'twitter:image',
					content: this.fetchedData.listing_cover_image_facebook.src,
				},
				{
					property: 'vk:image',
					content: this.fetchedData.listing_cover_image_facebook.src,
				},

				{
					name: 'image',
					property: 'og:image',
					content: this.fetchedData.smm_image_default.src || this.fetchedData.listing_cover_image_facebook.src,
				},
				{
					name: 'author',
					content: 'SKOLKOVO',
				},
			],
		};
	},
	computed: {
		links() {
			if (!this.eventPage) return [];

			const {
				event_pages: pages,
				slug,
				title,
			} = this.eventPage;
			if (!Array.isArray(pages) || pages.length === 0) return false;
			const links = pages.map(({
				slug: path,
				title: name,
				active,
			}) => ({
				path: `/programmes/${slug}/${path}/`,
				name,
				active,
			}));
			links.unshift({
				path: `/programmes/${slug}/`,
				title,
				home: true,
			});

			return links;
		},

		cardMenuItems() {
			if (!this.fetchedData || !this.fetchedData.blocks) return {};

			if (_find(this.fetchedData.blocks, { type: 'panel-cards' })) {
				const { items } = _find(this.fetchedData.blocks, { type: 'panel-cards' });
				return items.map((item) => ({
					title: item.title,
					uri: `#card-${item.position}`,
				}));
			}

			return {};
		},
		check() {
			return (!this.$auth.user && this.$store.state.alumni.projectArticle)
				|| (!this.isAlumni && this.fetchedData.is_alumni);
		},
		isAlumni() {
			return this.$store.getters['profile/isAlumni'];
		},
		notAlumniPage() {
			return this.$store.state.alumni.projectArticle;
		},
	},
	watch: {
		'$auth.user': {
			handler(user) {
				if (user) {
					this.entity_id = this.fetchedData.id;

					const data = {
						entity: this.entity,
						entity_id: this.entity_id,
					};

					this.$api.inLibrary(data)
						.then((response) => {
							this.inLibrary = response;
						});
				}
			},
			immediate: true,
		},
	},
	created() {
		if (process.browser) {
			window.addEventListener('scroll', this.onScroll);
		}
		this.checkValue();
		if (this.$store.state.alumni.projectArticle && !this.$auth.loggedIn) {
			this.showLoginPopup();
		}
	},
	destroyed() {
		if (process.browser) {
			window.removeEventListener('scroll', this.onScroll);
		}
	},
	analyticTags() {
		return {
			type: this.fetchedData.type,
			content_type: this.fetchedData.taxonomy_type_title,
			subject: this.fetchedData.title,
			product: this.fetchedData.taxonomy?.product ? this.fetchedData.taxonomy.product.title : '',
			business_direction: this.fetchedData.taxonomy?.project ? this.fetchedData.taxonomy.project.title : '',
			profile_section: this.fetchedData.taxonomy?.section ? this.fetchedData.taxonomy.section.title : '',
			// subject: this.event.topics, // todo проработать массив
		};
	},
	jsonld() {
		let data = {};
		try {
			data = jsonldForArticles(this.fetchedData);
		} catch (e) {
			// this.$logger.log(e);
		}

		return data;
	},
	mounted() {
		if (this.fetchedData) {
			if (!this.fetchedData.is_has_blocks && this.fetchedData.project_content_download_link) {
				window.location.replace(this.fetchedData.project_content_download_link);
			}
			if (this.fetchedData.taxonomy.project && this.fetchedData.taxonomy.project.chat_id) {
				this.loadJivo(this.fetchedData.taxonomy.project.chat_id);
			} else {
				this.loadJivo();
			}
		}
	},
	methods: {
		...mapActions({
			showLoginPopup: 'authModal/showLogin',
			loadJivo: 'scripts/loadJivo',
		}),
		...mapMutations({
			checkAlumni: 'alumni/projectArticle',
		}),
		checkValue() {
			if (this.fetchedData.is_alumni === true) {
				this.checkAlumni(true);
			}
		},
		phoneUpdate(payload) {
			this.showPhoneValidationError = !payload.isValid;
			this.isMobilePhoneValid = payload.isValid;
			if (!payload.isValid) {
				this.subscribeForm.phone = null;
			} else {
				this.countryCode = payload.countryCode;
				this.subscribeForm.phone = payload.formatInternational;
			}
		},
		formSubmit() {
			this.subscribeForm.triedToSend = true;

			if (this.$v.subscribeForm.$invalid || this.$v.agreements.$invalid) {
				return;
			}

			this.setAgreementFields();

			const leadData = this.makeLeadData();

			axios({
				url: `${process.env.baseURL}/api/v2/leadsintegration/save`,
				data: leadData,
				method: 'post',
				contentType: 'application/x-www-form-urlencoded',
				crossDomain: true,
				async: false,
			}).then((response) => {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'form_send',
					form_data: leadData,
				});

				let extendedRegistrationString = '';
				if (response.data.isExtendedRegistration) {
					extendedRegistrationString = `&uuid=${response.data.uuid}`;
				}

				alert('Спасибо за подписку!');
			})
				.catch((error) => {
					console.error(error);
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: 'form_send',
						form_data: leadData,
					});
					alert('Произошла ошибка, попробуйте еще раз');
				});
		},
		makeLeadData() {
			const clientID = typeof yaCounter994527 !== 'undefined'
				? yaCounter994527.getClientID()
				: '';
			const { UAClientID } = window;
			const BpmRef = this.$cookies.get('bpmRef') || '';
			const BpmHref = this.$cookies.get('bpmHref') || '';
			const roistatVisitId = this.$cookies.get('roistat_visit') || '';

			const leadData = {
				landingId: 'bb59d8da-e3ac-42e7-a08b-f3312568497a',
				leadFields: {
					TsContactGivenName: this.subscribeForm.firstName,
					TsContactSurname: this.subscribeForm.lastName,
					Email: this.subscribeForm.email,
					MobilePhone: this.subscribeForm.phone,
					SkGAClientId:
						typeof UAClientID !== 'undefined' ? UAClientID : '',
					SkYMClientId:
						typeof clientID !== 'undefined' ? clientID : '',
					roistatVisitId:
						typeof roistatVisitId !== 'undefined' ? roistatVisitId : '',
					BpmRef,
					BpmHref,
					TsAdditionalInformation: `email-подписка, ${location.href}`,
					sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
					sklAgreedPersonalData: this.agreements.personal_data,
					sklTargetAction: 'Подписка на новости',
				},
			};

			return leadData;
		},
		async addLibraryItem() {
			if (!this.$auth.$state.user) {
				this.showLoginModal();
			} else {
				const data = {
					entity: this.entity,
					entity_id: this.entity_id,
				};

				await this.$api.addLibraryItem(data)
					.then((response) => {
						this.inLibrary = response;
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		async delLibraryItem() {
			if (!this.$auth.$state.user) {
				this.showLoginModal();
			} else {
				const data = {
					entity: this.entity,
					entity_id: this.entity_id,
				};

				await this.$api.delLibraryItem(data)
					.then((response) => {
						this.inLibrary = !response;
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		showLoginModal() {
			if (this.isShowLoginModal && !this.$auth.loggedIn) {
				this.isShowLoginModal = false;
				this.showLoginPopup();
			}
		},
		onScroll() {
			const elem = document.getElementsByClassName('media_cards');

			for (let i = 0; i < elem.length; i++) {
				const posTop = elem[i].getBoundingClientRect().top;

				if (posTop >= -100 && posTop <= 100) {
					this.resetStyles(elem.length);

					const btn = this.$refs[`btn-${i}`];
					if (btn) {
						btn[0].style.borderBottom = '2px solid #000000';
					}
				}
			}
		},
		resetStyles(count) {
			for (let i = 0; i < count; i++) {
				const btn = this.$refs[`btn-${i}`];
				if (btn) {
					btn[0].style.borderBottom = '';
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
// Стили, внедренные сюда не стоят "scoped" и действуют на всё на этой странице !!!
@import "~/assets/styles/components/home/panel-about_program";
@import "~/assets/styles/components/layouts/event-search-header";
@import "~/assets/styles/components/layouts/questions-page";
// @import "~/assets/styles/components/home/panel-partners";
@import "~/assets/styles/components/home/panel-smart-form";
@import "~/assets/styles/components/home/panel-subscribe-short";

.subscription-wrapper {
	background: #eee;
	position: relative;
	z-index: 10;
}

.subscription {
	border-radius: 8px;
}
</style>

<style lang="scss">
@import "~/assets/styles/components/layouts/article-detail";
@import "~/assets/styles/components/layouts/side-menu.scss";

label.input-error {
	left: 13px;
	position: absolute;
    bottom: 0.4rem;
    line-height: 1;
    font-size: 0.8rem;
    margin: 0;
    color: #FFFF00;
}
.ny2022 {
	position: relative;
	height: 100vh;
	overflow: hidden;
	&::before {
		content: 'Наш календарь открывается 31 декабря';
		background-image: url('https://sk.skolkovo.ru/img/6b55e9ca-d3f6-44c6-826a-031107c8f485/photo-2021-12-23-160503.jpeg');
		position: absolute;
		width: 100vw;
		height: 100vh;
		padding: 2rem;
		top: 0;
		z-index: 5;
		color: $white;
		font-size: 2.5rem;
		align-items: center;
		justify-content: center;
		display: flex;
	}

}
.key .subtitle p {
	&:last-child {
		margin-bottom: 0;
	}
}
.input-tel__label {
	top: -8px !important;
}
</style>
